import { useState, useEffect } from 'react';

interface ResponsiveBreakpoints {
  isMobile: boolean;
  isSmallMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  width: number;
}

export const useResponsive = (): ResponsiveBreakpoints => {
  const [breakpoints, setBreakpoints] = useState<ResponsiveBreakpoints>({
    isMobile: typeof window !== 'undefined' && window.innerWidth < 768,
    isSmallMobile: typeof window !== 'undefined' && window.innerWidth < 480,
    isTablet: typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth < 992,
    isDesktop: typeof window !== 'undefined' && window.innerWidth >= 992,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints({
        isMobile: window.innerWidth < 768,
        isSmallMobile: window.innerWidth < 480,
        isTablet: window.innerWidth >= 768 && window.innerWidth < 992,
        isDesktop: window.innerWidth >= 992,
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial call

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoints;
};
